import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getTranslation } from '@shared/translate-helper';

@Component({
  selector: 'app-internal-server-error',
  templateUrl: './internal-server-error.component.html',
  styleUrls: ['./internal-server-error.component.scss'],
  standalone: false,
})
export class InternalServerErrorComponent implements OnInit {
  public errorCode: string = '500';
  public errorTitle!: string;
  public errorDescription!: string;
  public quickTip!: string;

  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {
    getTranslation(this.translateService, ['500_title', '500_description', '500_quick_tip']).subscribe((t) => {
      this.errorTitle = t['500_title'];
      this.errorDescription = t['500_description'];
      this.quickTip = t['500_quick_tip'];
    });
  }
}
